import { Dialog } from "~/ui-rtk/components/ui/common"
import { CloseSvg } from "~/ui-rtk/components/ui/svg/essentials"
import { H2 } from "~/ui-rtk/components/ui/typography"
import {
  SOS_BOOK_A_CALL_URL,
  SOS_REPORT_READY_BODY,
  SOS_REPORT_READY_HEADLINE,
} from "~/ui-rtk/constants/sos"

type TSosReportReadyPopupProps = {
  onClose: () => void
}

/**
 * One-time "your report is ready" popup on the SoS report (APP-487).
 * Presentational: useSosReportReadyPopup (./connect) owns the once-per-stamp
 * visibility, and SosReportDialogs coordinates it against the recurring
 * upsell modal so only one dialog auto-opens per visit.
 */
export default function SosReportReadyPopup({
  onClose,
}: TSosReportReadyPopupProps) {
  return (
    <Dialog isOpen handleClose={onClose} width={440} closeOnClickOutside>
      <div className="relative rounded-md py-8 px-8 bg-basic-dark-blue shadow-deep border border-basic-blue text-center flex flex-col items-center gap-4">
        {/* First in DOM order + data-autofocus so keyboard users land on the
            dismiss control, not the external CTA. */}
        <button
          aria-label="Close"
          data-autofocus
          className="absolute right-4 top-4 max-w-7 max-h-7 p-2 flex items-center justify-center hover:bg-[#2a2c33] hover:text-white transition-colors rounded-1"
          onClick={onClose}
        >
          <CloseSvg size={20} fill="platinum" />
        </button>
        <H2>{SOS_REPORT_READY_HEADLINE}</H2>
        <p className="opacity-70">{SOS_REPORT_READY_BODY}</p>
        <a
          href={SOS_BOOK_A_CALL_URL}
          target="_blank"
          rel="noreferrer"
          className="btn btn-primary btn-wide mt-2"
        >
          Pick a time
        </a>
      </div>
    </Dialog>
  )
}
